<template>
  <bita-modal
    id="walletTransactionsModal"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="number"
              name="name"
              style="direction: ltr"
              label="مبلغ"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.price"
            />
            <bita-input
              type="text"
              name="family"
              label="توضیح"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.description"
            />
            <bita-bootbutton
              type="primary transaction"
              title="ذخیره"
              icon="fa fa-check"
              btn-width="150px"
              @click.native="handleSubmit()"
            />
          </div>
        </div>
      </bita-form>
      <bita-grid
        ref="grid"
        :columns="gridColumns"
        :read-data="readData"
        :server-paging="true"
        :batch="true"
        :resizable="true"
        :grid-server-side="true"
        :schema-total="'total'"
        :schema-data="'data'"
        :page-size="pageSize"
        :current-page="currentPage"
        :auto-bind="false"
      />
    </div>
  </bita-modal>
</template>
<script>
import { userApi } from "@/api/apiManagement.js";

export default {
  data() {
    return {
      colWidth: "col-lg-4 col-md-6 col-sm-6",
      isLoading: false,
      transactions: [],
      dataForm: {},
      user: {},
      pageSize: 10,
      currentPage: 1,
    };
  },
  computed: {
    title() {
      return `تراکنش های کیف پول ${this.user.full_name}`;
    },
    gridColumns() {
      return [
        {
          field: "type_name",
          title: "عنوان سایت",
        },
        {
          field: "price",
          title: "مبلغ",
          template: ({ price, transaction_type }) => {
            let priceClass = "";

            if (transaction_type == 1) priceClass = "text-success";
            else priceClass = "text-danger";

            return (
              `<span class="${priceClass}">` +
              (price ? price : " - ") +
              `</span>`
            );
          },
        },
        {
          field: "cumulative_sum",
          title: "مجموع",
        },
        {
          field: "description",
          title: "توضیحات",
          template: ({ description }) => (description ? description : "-"),
        },
        {
          field: "created_at",
          title: "تاریخ",
          template: ({ created_at }) => this.$getJalaliDateTime(created_at),
        },
      ];
    },
  },
  methods: {
    init(user) {
      this.user = user;
      this.isLoading = true;
      this.$showModal("#walletTransactionsModal");
      this.loadData();
    },
    readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;

      userApi
        .getUserWalletTransactions(this.user.id, {
          page_size: this.pageSize,
          page: this.currentPage,
        })
        .then(({ data }) => {
          e.success(data.entity);
          this.$emit("on-reload");
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.isLoading = true;
          userApi
            .createUserWalletTransactions(this.user.id, this.dataForm)
            .then(({ data }) => {
              this.reset();
            })
            .finally(() => {
              this.isLoading = false;
              this.loadData();
            });
        }
      });
    },
    reset() {
      this.dataForm = {};
      this.$refs.form.reset();
    },
    setErrors(_errors) {
      this.$refs.form.setErrors(_errors);
    },
    onCloseModal(e) {
      this.$emit("on-close");
      this.reset();
    },
    onModelChange(e) {
      // this.$refs.modelIDDropDown.emptyKendo()
      this.$emit("change-model-type", e);
    },
  },
};
</script>
<style scoped>
img {
  width: 75px;
  max-height: 120px;
}
.custom-file-label {
  padding: 0.5rem 4.2rem 0 0;
}
.center-align {
  text-align: center;
}
.btn-primary.transaction {
  margin: 25px auto 0 auto !important;
  height: 39px;
}
</style>
